import React, { useState } from 'react';
import BankList from '../components/BankList';
import BankForm from '../components/BankForm';
import useWindowWidth from '../hooks/useWindowWidth';
import '../components/RevenueDesktop.css';

function BanksPage() {
  const [editingBank, setEditingBank] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const width = useWindowWidth();

  const handleEdit = (bank) => {
    setEditingBank(bank);
    setShowForm(true);
  };

  const handleNewBank = () => {
    setEditingBank(null);
    setShowForm(true);
  };

  const handleSuccess = () => {
    setShowForm(false);
    setEditingBank(null);
    // Optionally, refresh the bank list here if it's not handled by a global state
  };

  const isDesktop = width >= 768;

  return (
    <div>
      {/* ── Desktop header ── */}
      {isDesktop && !showForm && (
        <div className="rv-page-header">
          <div className="rv-page-header-title">
            <h1>Bancos</h1>
            <p>Gerencie suas contas bancárias</p>
          </div>
          <button className="rv-btn rv-btn-primary" onClick={handleNewBank}>
            + Novo Banco
          </button>
        </div>
      )}

      {/* ── Mobile header (mantido exatamente como era) ── */}
      {!isDesktop && <h1>Gerenciamento de Bancos</h1>}
      {!isDesktop && !showForm && (
        <button className="btn btn-success mb-3" onClick={handleNewBank}>Adicionar Novo Banco</button>
      )}

      {showForm ? (
        <div>
          {isDesktop
            ? <p className="rv-form-heading">{editingBank ? 'Editar Banco' : 'Novo Banco'}</p>
            : <h2>{editingBank ? 'Editar Banco' : 'Criar Novo Banco'}</h2>
          }
          <BankForm bank={editingBank} onSuccess={handleSuccess} />
          <button className="btn btn-secondary mt-3" onClick={() => setShowForm(false)}>Cancelar</button>
        </div>
      ) : (
        <BankList onEdit={handleEdit} />
      )}
    </div>
  );
}

export default BanksPage;
